import type { PersonInvolvementKind } from "../types/involvement.js";

/**
 * The involvement kinds a person's case cannot run without: an organisation
 * accountable for the person, a responsible user, and somebody whose
 * assessment will stand. An approver is not among them, because nothing needs
 * approving until an assessment is finished.
 */
export const requiredInvolvementKinds = [
  "duty_of_care",
  "responsible_user",
  "designated_assessor",
] as const satisfies readonly PersonInvolvementKind[];
